import { render, staticRenderFns } from "./WizardCard.vue?vue&type=template&id=2f0c0214&"
import script from "./WizardCard.vue?vue&type=script&lang=js&"
export * from "./WizardCard.vue?vue&type=script&lang=js&"
import style0 from "./WizardCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports